import React, { useEffect, useState } from "react";
import { Field, reduxForm } from "redux-form";
import { connect } from "react-redux";
import FooterForm from "../../../Components/Lib/FooterForm";
import { renderAField, renderTextField } from "../../../Components/Forms/renders";
import switcbutton from "../../../Components/Forms/switch";
import renderDaterange from "../../../Components/Forms/daterange";
import { fetchervaringen } from "../../Ervaringen/Reducers/actions";
import SelectBox from "../../../Components/Forms/selectbox";
import { fetcharrangementen } from "../../Arrangementen/Reducers/actions";
import { fetchUserOrganisaties } from "../Reducers/items/actions";

const SyncValidationForm = ({ handleSubmit, fetchervaringen, fetcharrangementen, fetchUserOrganisaties, user, isEvenement }) => {
  const [ervaringen, setervaringen] = useState([]);
  const [arrangementen, setarrangementen] = useState([]);
  const [userorganisaties, setuserorganisaties] = useState([]);

  const isLocatiebeheerder = user?.role === 'locatiebeheerder';
  useEffect(() => {
    fetchervaringen().then((data) => {
      setervaringen(data.results);
      fetcharrangementen().then((data) => {
        setarrangementen(data.results);
      });
    });

    // Partner-organisaties ophalen voor de koppel-dropdown (admin/manager).
    if (user?.role === 'admin' || user?.role === 'manager') {
      fetchUserOrganisaties().then((orgs) => {
        setuserorganisaties(orgs || []);
      });
    }
  }, []);

  return (
    <form onSubmit={handleSubmit}>
      <div className="col-sm-12">
        <h4 className="info-text">Vul hier de eigenschappen in </h4>
      </div>

      {!isLocatiebeheerder && (
        <div className="box">
          <div className="box-header with-border">
            <h3 className="box-title">Partner-organisatie</h3>
          </div>
          <div className="box-body">
            <Field
              name="userorganisatie"
              inputvalue="_id"
              inputnaam="naam"
              options={[{ _id: "", naam: "— Geen partner-organisatie —" }, ...userorganisaties]}
              type="input"
              component={SelectBox}
              label="Kies bij welke partner-organisatie dit evenement of deze locatie hoort. Gebruikers van die organisatie kunnen het dan bewerken."
            />
          </div>
        </div>
      )}

      <div className="box">
        <div className="box-header with-border">
          <h3 className="box-title">Vul hier de prijzen in </h3>
        </div>
        <div className="box-body">
          <Field name="priceinformation.extrapriceinformation.value" type="input" component={renderTextField} label="Vul hier de informatie in over de prijzen" />
        </div>
      </div>
      {!isLocatiebeheerder && (
        <div className="box">
          <div className="box-header with-border">
            <h3 className="box-title">Externe partners </h3>
          </div>
          <div className="box-body">
            <Field name="veluwedb.publiceren" type="input" component={switcbutton} label="Evenement publiceren naar Visit Veluwe" />
            <Field name="veluwedb.locatiepubliceren" type="input" component={switcbutton} label="Locatie publiceren naar Visit Veluwe" />
          </div>
        </div>
      )}
      <div className="box">
        <div className="box-header with-border">
          <h3 className="box-title">Toegankelijk </h3>
        </div>
        <div className="box-body">
          <Field name="location.toegankeijkheid.hondtoestaan" type="input" component={switcbutton} label="Zijn honden toegestaan?" />
          <Field name="location.toegankeijkheid.rolstoeltoegankelijk" type="input" component={switcbutton} label="Is de locatie rolstoeltoegankelijk?" />
          <Field name="location.toegankeijkheid.toegankelijkvoormindervaliden" type="input" component={switcbutton} label="Is de locatie toegankelijk voor mindervaliden?" />
        </div>
      </div>

      {!isLocatiebeheerder && (
        <div className="box">
          <div className="box-header with-border">
            <h3 className="box-title">Duurzaamheid </h3>
          </div>
          <div className="box-body">
            <Field name="location.duurzaamheid.greenkey" type="input" component={switcbutton} label="Heeft de locatie een greenkey?" />
          </div>
        </div>
      )}

      {!isLocatiebeheerder && (
        <div className="box">
          <div className="box-header with-border">
            <h3 className="box-title">Awards </h3>
          </div>
          <div className="box-body">
            <Field name="location.awards.michelin" type="input" component={switcbutton} label="Heeft de locatie een michelin award?" />
          </div>
        </div>
      )}

      {!isLocatiebeheerder && isEvenement && (
        <div className="box">
          <div className="box-header with-border">
            <h3 className="box-title">Uitgelicht evenement</h3>
          </div>
          <div className="box-body">
            <Field name="uitgelicht" type="input" component={switcbutton} label="Dit evenement extra uitlichten op externe sites (zoals wildetenopdeveluwe.nl)" />
          </div>
        </div>
      )}

      {!isLocatiebeheerder && (
        <div className="box">
          <div className="box-header with-border">
            <h3 className="box-title">Markeer als top item</h3>
          </div>
          <div className="box-body">
            <Field name="top.active" type="input" component={switcbutton} label="Zet dit items als top item actief" />
            <Field name="top.datum" component={renderDaterange} mindate={true} maxdate={true} label="In welke periode wil je het item laten zien" />
          </div>
        </div>
      )}

      {!isLocatiebeheerder && (
        <div className="box">
          <div className="box-header with-border">
            <h3 className="box-title">Dit is een webshop item</h3>
          </div>
          <div className="box-body">
            <Field name="metadata.product" component={renderAField} label="Vul de url van de webshop in (webshop/379/klompenmakerspad)" />
          </div>
        </div>
      )}

      {!isLocatiebeheerder && (
        <div className="box">
          <div className="box-header with-border">
            <h3 className="box-title">Is dit item online boekbaar</h3>
          </div>
          <div className="box-body">
            <Field name="metadata.boekbaarheid.status" type="input" component={switcbutton} label="Is dit item online boekbaar?" />
            <Field name="metadata.boekbaarheid.id" inputvalue="_id" inputnaam="naam" options={ervaringen} type="input" component={SelectBox} label="Kies om het item aan een ervaring te koppelen" />
            <Field name="metadata.boekbaarheid.arrangement" inputvalue="_id" inputnaam="naam" options={arrangementen} type="input" component={SelectBox} label="Kies om het item aan een arrangement te koppelen" />
          </div>
        </div>
      )}

      <FooterForm />
    </form>
  );
};

const ReduxFormSensorEdit = reduxForm({
  form: "eigenschappen_edit", // a unique identifier for this form
})(SyncValidationForm);

const mapStateToProps = (state) => ({
  initialValues: state.items.item, // pull initial values from account reducer
  user: state.auth.user,
  isEvenement: state.items.item?.metadata?.entitytype === "EVENEMENT",
});

export default connect(mapStateToProps, { fetchervaringen, fetcharrangementen, fetchUserOrganisaties })(ReduxFormSensorEdit);
